import _ from 'lodash';

export const buildLocationMetadata = ({
  tab,
  sectionId,
  entityId,
  subsection,
  subtab,
  entityNameMap,
}) => {
  const entityName = !_.isNil(entityId) ? entityNameMap[entityId] : null;
  const subsectionName = !_.isNil(subsection) ? entityNameMap[subsection] : null;

  return {
    tab,
    ...(!_.isNil(sectionId) && { sectionId }),
    ...(!_.isNil(entityId) && {
      entityId,
      ...(!_.isNil(entityName) && { entityName }),
    }),
    ...(!_.isNil(subsection) && {
      subsection,
      ...(!_.isNil(subsectionName) && { subsectionName }),
    }),
    ...(!_.isNil(subtab) && {
      subtab,
      subtabName: _.startCase(subtab),
    }),
  };
};
